import React from 'react'

import { createPortal } from 'react-dom'

import ArcadeModal from './ArcadeModal'

export type ArcadeModalPortalProps = { rootId?: string } & React.ComponentProps<typeof ArcadeModal>

const ArcadeModalPortal = React.forwardRef<HTMLDivElement, ArcadeModalPortalProps>(
  ({ rootId = 'modal-root', ...props }, ref) =>
    createPortal(<ArcadeModal ref={ref} {...props} />, document.getElementById(rootId) as HTMLElement)
)

ArcadeModalPortal.displayName = 'ArcadeModalPortal'

export default ArcadeModalPortal
